import React from 'react';
import styled from 'styled-components';

const PanelWrapper = styled.div`
  font-family: 'Poppins', sans-serif; 
  background-color: #ECECEC;
  padding: 15px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

const EditorTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 10px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
`;

const MainClassInfo = styled.p`
    font-size: 12px;
    color: #555;
    margin: -5px 0 15px 0;
    font-family: monospace;
`;

const EditorContainer = styled.div`
  flex-grow: 1;
  overflow: hidden;
  border-radius: 4px;
`;

// Using your original StyledTextArea
const StyledTextArea = styled.textarea`
  width: 100%;
  height: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  font-family: monospace;
  box-sizing: border-box;
  resize: none;
  background-color: #F9F9F9;
  color: #2d2d2d;
  caret-color: #2d2d2d;

  &:focus {
    outline: none;
    border-color: #85B33E;
    box-shadow: 0 0 0 2px rgba(133, 179, 62, 0.2);
  }
`;

const Placeholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #777;
  font-size: 1.2rem;
`;

function CssEditorPanel({ objectGroups, selectedGroupId, allCss, setAllCss, setIsDirty }) {
  
  const selectedGroup = objectGroups.find(group => group.id === selectedGroupId);

  const onCodeChange = (event) => {
    const newCode = event.target.value;
    setIsDirty(true);
    
    setAllCss(prevCss => ({
      ...prevCss,
      [selectedGroupId]: newCode
    }));
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Tab') {
      // Prevent the default action of changing focus
      event.preventDefault();

      const { target } = event;
      const { selectionStart, selectionEnd } = target;

      const newValue = 
        target.value.substring(0, selectionStart) + 
        '\t' + 
        target.value.substring(selectionEnd);
      
      onCodeChange({ target: { value: newValue } });

      setTimeout(() => {
        target.selectionStart = target.selectionEnd = selectionStart + 1;
      }, 0);
    }
  };

  if (!selectedGroup) {
    return (
      <PanelWrapper>
        <Placeholder>
          Select an object group from the left to start editing.
        </Placeholder>
      </PanelWrapper>
    );
  }

  return (
    <PanelWrapper>
      <EditorTitle>
        Editing Styles for: <strong>{selectedGroup.name}</strong>
      </EditorTitle>
      <MainClassInfo>
        Main Class: <strong>{selectedGroup.mainClass}</strong>
      </MainClassInfo>
      <EditorContainer>
        <StyledTextArea
          value={allCss[selectedGroupId] || ''}
          onChange={onCodeChange}
          onKeyDown={handleKeyDown}
          placeholder="Enter your CSS rules here..."
        />
      </EditorContainer>
    </PanelWrapper>
  );
}

export default CssEditorPanel;